(() => {
  const REQUEST_TIMEOUT_MS = 15000;

  function initializeWithdrawalForm(form) {
    if (form.dataset.withdrawalInitialized === 'true') return;
    form.dataset.withdrawalInitialized = 'true';

    const submitButton = form.querySelector('[data-withdrawal-submit]');
    const submitLabel = form.querySelector('[data-withdrawal-submit-label]');
    const loadingLabel = form.querySelector('[data-withdrawal-loading-label]');
    const intro = form.parentElement.querySelector('.withdrawal__intro');
    const successState = form.parentElement.querySelector('[data-withdrawal-success]');
    const errorState = form.parentElement.querySelector('[data-withdrawal-error]');
    const successOrder = successState.querySelector('[data-withdrawal-order]');
    let submitting = false;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (submitting || !form.reportValidity()) return;

      const nameInput = form.elements.namedItem('name');
      const emailInput = form.elements.namedItem('email');
      const orderInput = form.elements.namedItem('order_number');
      const confirmationInput = form.elements.namedItem('withdrawal_confirmed');

      nameInput.value = nameInput.value.trim();
      emailInput.value = emailInput.value.trim();
      orderInput.value = orderInput.value.trim();

      if (!form.reportValidity()) return;

      const payload = {
        name: nameInput.value,
        email: emailInput.value,
        order_number: orderInput.value,
        withdrawal_confirmed: confirmationInput.checked,
        locale: form.dataset.locale || '',
        country: form.dataset.country || '',
        market: form.dataset.market || '',
        page_url: form.dataset.pageUrl || window.location.href
      };

      const webhookUrl = (form.dataset.webhookUrl || '').trim();
      const controller = new AbortController();
      const timeoutId = window.setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

      submitting = true;
      submitButton.disabled = true;
      submitButton.setAttribute('aria-disabled', 'true');
      submitLabel.classList.add('hidden');
      loadingLabel.classList.remove('hidden');
      errorState.classList.add('hidden');

      try {
        if (!/^https:\/\//i.test(webhookUrl)) {
          throw new Error('Withdrawal webhook URL has not been configured.');
        }

        const response = await fetch(webhookUrl, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal: controller.signal
        });

        if (!response.ok) {
          throw new Error(`Withdrawal webhook returned HTTP ${response.status}.`);
        }

        successOrder.textContent = payload.order_number;
        form.classList.add('hidden');
        intro.classList.add('hidden');
        errorState.classList.add('hidden');
        successState.classList.remove('hidden');
        successState.focus();
      } catch (error) {
        console.error('Withdrawal form submission failed.', error);
        errorState.classList.remove('hidden');
        errorState.focus();
      } finally {
        window.clearTimeout(timeoutId);
        submitting = false;
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        submitLabel.classList.remove('hidden');
        loadingLabel.classList.add('hidden');
      }
    });
  }

  function initializeAllWithdrawalForms(root = document) {
    root.querySelectorAll('[data-withdrawal-form]').forEach(initializeWithdrawalForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAllWithdrawalForms());
  } else {
    initializeAllWithdrawalForms();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAllWithdrawalForms(event.target));
})();

